/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addacoverimagetopublish15Inputs */

const en_addacoverimagetopublish15 = /** @type {(inputs: Addacoverimagetopublish15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an image to publish`)
};

const de_addacoverimagetopublish15 = /** @type {(inputs: Addacoverimagetopublish15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füg ein Bild hinzu, um zu veröffentlichen.`)
};

/**
* | output |
* | --- |
* | "Add an image to publish" |
*
* @param {Addacoverimagetopublish15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addacoverimagetopublish15 = /** @type {((inputs?: Addacoverimagetopublish15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addacoverimagetopublish15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addacoverimagetopublish15(inputs)
	return de_addacoverimagetopublish15(inputs)
});
export { addacoverimagetopublish15 as "addACoverImageToPublish1" }